import { createContext, useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-hot-toast";

import API from "services/api";

export const AuthContext = createContext({
  login: () => {},
  signUp: () => {},
  verifyMultiRole: () => {},
  logout: () => {},
  saveToLocalStorage: () => {},
  authenticated: !!localStorage.getItem("access_token"),
  setAuthenticated: () => {},
  loading: false,
});

export default function AuthProvider(props) {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(
    !!localStorage.getItem("access_token")
  );
  const [loading, setLoading] = useState(false);
  const saveToLocalStorage = (name, data) => {
    localStorage.setItem(name, data);
  };
  const signIn = useCallback(async (values) => {
    // try {
    setLoading(true);
    try {
      const res = await API.postLogin(values);
      const resdata = res.data;

      if (resdata !== null) {
        const success = resdata.success;
        if (success) {
          const { token, roles, multi } = resdata.data;
          if (multi) {
            localStorage.setItem("roles", JSON.stringify(roles));

            return navigate(`/verify-role?token=${token}`);
          }
        }
        const _accessToken = resdata.data.accessToken;

        localStorage.setItem("access_token", _accessToken);
        localStorage.setItem("user", resdata.data.name);
        localStorage.setItem("refresh_token", resdata.data.refreshToken);
        toast.success("Selamat datang " + resdata.data.name);
        
        setAuthenticated(() => true);
        setLoading(false);
        window.location.pathname = "/";
      } else {
        console.log("running false");
        toast.error("Username atau password salah");

        setAuthenticated(false);
        setLoading(false);
      }
    } catch (error) {

      setAuthenticated(false);
      setLoading(false);

      throw error;
    }
  }, []);

  const signUp = (values) => {
    setLoading(true);
    API.postRegister(values)
      .then((res) => {
        console.log("success register");

        navigate("/");
        setLoading(false);
      })
      .catch((err) => {
        console.log("err register", err);
      });
  };

  const verifyMultiRole = useCallback(async (values) => {
    await API.verifySignInRole(values)
      .then((res) => {
        const data = res.data.data;
        if (data) {
          const _accessToken = data.accessToken;
          const _refreshToken = data.refreshToken;

          localStorage.setItem("access_token", _accessToken);
          localStorage.setItem("refresh_token", _refreshToken);
          localStorage.setItem("user", data.name);
          setAuthenticated(() => true);
          // navigate to app page
          window.location.pathname = "/";
          // navigate("/");
          toast.success("Selamat datang " + data.name);

          // setAuthenticated(true);
        }
      })
      .catch((err) => {
        console.log("error", err);
        toast.error("Terjadi kesalahan");
        window.location.href = "/login";
        // return navigate("/login", { replace: true });
      });
  }, []);

  const logout = useCallback(async () => {
    localStorage.clear();

    window.location.replace("/login");
  }, []);

  return (
    <AuthContext.Provider
      value={{
        signIn,
        logout,
        authenticated,
        loading,
        verifyMultiRole,
        setAuthenticated,
        signUp,
        saveToLocalStorage,
      }}
      {...props}
    />
  );
}
